import { lazy } from 'react';
const PaidTimeOff = lazy(() => import('./paid_time_off/paid_time_off'));
const PaidTimeOffDetails = lazy(() => import('./paid_time_off/paid_time_off_details'));
const Sidebar = lazy(() => import('./sidebar/sidebar').then((module) => ({ default: module.Sidebar })));
const Footer = lazy(() => import('./footer/footer'));
const Emerg_Contacts = lazy(() => import('./emerg_contacts/emerg_contacts'));
const GWEmergContactsUpd = lazy(() => import('./emerg_contacts/emerg_contacts_upd'));
const DashBoard = lazy(() => import('./dashboard/dashboard'));
const EEpassword = lazy(() => import('./ee_password/ee_password'));
const EE_Language = lazy(() => import('./ee_language/ee_language'));
const Login = lazy(() => import('./login/login'));
const PasswordRecovery = lazy(() => import('./password_recovery/password_recovery'));
const AcceptPolicy = lazy(() => import('./accept_policy/accept_policy'));
const PasswordExpiry = lazy(() => import('./password_expiry/password_expiry'));
const Education = lazy(() => import('./ee_education/ee_education'));
const EducationAddEdit = lazy(() => import('./ee_education/ee_addedit'));
const EducationDetails = lazy(() => import('./ee_education/ee_details'));
const SalaryHistory = lazy(() => import('./salary_history/salary_history'));
const SalaryHistoryDetail = lazy(() => import('./salary_history/salary_history_detail'));
const AppPage = lazy(() => import('./header/header').then((module) => ({ default: module.AppPage })));
const AppHeader = lazy(() => import('./header/header').then((module) => ({ default: module.AppHeader })));
const PrintPreference = lazy(() => import('./direct_deposits/print_prefrence/print_preference'));
const UpdatePrintPreference = lazy(() => import('./direct_deposits/print_prefrence/update_print_preference/update_print_preference'));
const notificationElection = lazy(() => import('./notification_election/notification_election'));
const BenefitsFTEMenu = lazy(() => import('./first_time_enrollment/benefits_FTE_menu'));
const BenefitsFTEPrsonalInfo = lazy(() => import('./first_time_enrollment/benefits_FTE_personal_info'));
const BenefitsFTEDependents = lazy(() => import('./first_time_enrollment/benefits_FTE_dependents'));
const BenefitsFTEVerify = lazy(() => import('./first_time_enrollment/benefits_FTE_verify'));
const BenefitsFTEElectBenefits = lazy(() => import('./first_time_enrollment/benefits_FTE_elect_benefits'));
const BenefitsFTEReviewBenefits = lazy(() => import('./first_time_enrollment/benefits_FTE_review'));
const BenefitsFTE = lazy(() => import('./first_time_enrollment/benefits_FTE_benefits'));
const Dependents = lazy(() => import('./dependents/dependents'));
const GWDependents = lazy(() => import('./dependents/dependents_upd'));
const GWDependentsAddDoc = lazy(() => import('./dependents/dependents_doc').then((module) => ({ default: module.GWDependentsAddDoc })));
const TrainingClasses = lazy(() => import('./training_classes/training_classes'));
const TrainingEnrollment = lazy(() => import('./training_enrollment/training_enrollment'));
const Paystub = lazy(() => import('./pay_stub/pay_stub'));
const PaystubDetails = lazy(() => import('./pay_stub/pay_stub_details'));
const PayStubPrintPreview = lazy(() => import('./pay_stub/pay_stub_print_preview'));
const Email_Address = lazy(() => import('./email_address/email_address'));
const EMailAddrAddUpdate = lazy(() => import('./email_address/email_address_upd'));
const PersonalData = lazy(() => import('./personal_data/personal_data'));
const PersonalDataEdit = lazy(() => import('./personal_data/personal_data_edit'));
const VolSelfIdDis = lazy(() => import('./vol_self_id_dis/vol_self_id_dis'));
const VolSelfIdDisUpd = lazy(() => import('./vol_self_id_dis/vol_self_id_dis_upd'));
const Employee_Direcotry = lazy(() => import('./employee_directory/employee_directory'));
const EEConsent1095C = lazy(() => import('./ee_consent/ee_consent'));
const EEConsentW2 = lazy(() => import('./ee_consent/ee_consentW2'));
const EEW2ConsentFormUpdate = lazy(() => import('./ee_consent/ee_consent_updW2'));

const EEConsentFormUpdate = lazy(() => import('./ee_consent/ee_consent_upd'));
const Employee_Files = lazy(() => import('./employee_files/employee_files'));
const JobReviews = lazy(() => import('./job_reviews/job_reviews'));
const JobReviewsDetail = lazy(() => import('./job_reviews/job_reviews_detail'));
const EECertifications = lazy(() => import('./ee_certifications/ee_certifications'));
const CertificationsAddEdit = lazy(() => import('./ee_certifications/ee_certifications_addedit'));
const Address_Information = lazy(() => import('./address_information/add_info'));
const addInfoUpd = lazy(() => import('./address_information/Add_info_upd'));
const BenefitStatement = lazy(() => import('./benefit_statement/benefit_statement'));
const DirectDepositAccount = lazy(() => import('./direct_deposits/account/account'));
const DirectDepositAccountListing = lazy(() => import('./direct_deposits/account/account_listing'));
const AddUpdateAccount = lazy(() => import('./direct_deposits/account/account_add_edit'));
const EESkills = lazy(() => import('./ee_skills/ee_skills'));
const EESkillsAddList = lazy(() => import('./ee_skills/ee_skills_add_list'));
const EESkillsAddSubmit = lazy(() => import('./ee_skills/ee_skills_add'));
const EESkillsUpdSubmit = lazy(() => import('./ee_skills/ee_skills_upd'));
const Total_Compensation_Stmt = lazy(() => import('./tot_comp_stmt/tot_comp_stmt'));
const W2history = lazy(() => import('./w2_history/w2_history'));
const FormC1095 = lazy(() => import('./formC1095/formC1095'));
const Benefit_Beneficiaries = lazy(() => import('./benefit_beneficiaries/benefit_beneficiaries'));
const Benefit_Beneficiaries_Detail = lazy(() => import('./benefit_beneficiaries/benefit_beneficiaries_detail'));
const Beneficiaries_Detail_Upd = lazy(() => import('./benefit_beneficiaries/beneficiaries_detail_upd'));
const Rendered_Web_Page = lazy(() => import('./rendered_web_pages/rendered_web_pages'));
const BenefitsOPEMenu = lazy(() => import('./open_enrollment/benefits_OPE_menu'));
const BenefitsOPEPersonalInfo = lazy(() => import('./open_enrollment/benefits_OPE_personal_Info'));
const BenefitsOPEDependents = lazy(() => import('./open_enrollment/benefits_OPE_dependents'));
const BenefitsOPEVerify = lazy(() => import('./open_enrollment/benefits_OPE_verify'));
const BenefitsOPEElectBenefits = lazy(() => import('./open_enrollment/benefits_OPE_elect_benefits'));
const BenefitsOPEReviewBenefits = lazy(() => import('./open_enrollment/benefits_OPE_review'));
const BenefitsOPE = lazy(() => import('./open_enrollment/benefits_OPE_benefits'));
const PaycheckCalculator = lazy(() => import('./paycheck_caclulator/paycheck_calculator'));
const PaycheckCalculatorResult = lazy(() => import('./paycheck_caclulator/paycheck_calculator_result'));
const Retirement_Deduction = lazy(() => import('./retirement_deduction/retirement_deduction'));
const Retirement_Deduction_Add = lazy(() => import('./retirement_deduction/retirement_deduction_add'));
const Mfa_header = lazy(() => import('./multi_factor_authentication/mfa_header'));
const Mfa_login = lazy(() => import('./multi_factor_authentication/mfa_login'));
const W4_Forms = lazy(() => import('./w4_forms/w4_forms'));
const W4_Forms_fed = lazy(() => import('./w4_forms/w4_forms'));

const W4_Forms_date = lazy(() => import('./w4_forms/w4_forms_date'));
const W4_Forms_iframe = lazy(() => import('./w4_forms/w4_forms_iframe'));
const listingI9Listing = lazy(() => import('./i_9/i_9_listing'));
const I9SummarylistContext = lazy(() => import('./i_9/summary_list'));
const I9ListMenu = lazy(() => import('./i_9/i9_menu_list'));
const I9FirstReadInstruction = lazy(() => import('./i_9/i9_read_instruction_first'));
const I9SecondPersonalInfo = lazy(() => import('./i_9/i9_personal_info_second'));
const I9ThirdCitizenship = lazy(() => import('./i_9/i9_citizenship_third'));
const I9FourthEligibility = lazy(() => import('./i_9/i9_eligibility_fourth'));
const I9EligibilityProceed = lazy(() => import('./i_9/i9_eligibility_proceed'));
const Onboarding = lazy(() => import('./onboarding/onboarding'));
const OnboardNavbar = lazy(() => import('./onboarding/navigation_bar/navigation_bar'));
const W4 = lazy(() => import('./w4/w4'));
const W4_date = lazy(() => import('./w4/w4_date'));
const BenefitsLifeEventsList = lazy(() => import('./life_events/life_event_list'));
const BenefitsLifeEventsMenu = lazy(() => import('./life_events/life_event_menu'));
const BenefitsLifeEventsInfo = lazy(() => import('./life_events/life_event_info'));
const BenefitsLifeEventsDependent = lazy(() => import('./life_events/life_event_depentents'));
const BenefitsLifeEventsVerify = lazy(() => import('./life_events/life_event_verify'));
const BenefitsLifeEventsElectBenefits = lazy(() => import('./life_events/life_event_elect_benefits'));
const BenefitsLifeEventsReview = lazy(() => import('./life_events/life_event_benefits_review'));
const BenefitsLifeEvents = lazy(() => import('./life_events/life_event_submit'));
const Login_Customer = lazy(() => (import('./login/login_customer')));
const Address_Information_W4 = lazy(() => (import('./address_information/Add_info_w4')));

/*mod component called*/
import { modComponentsModules } from '../mods/components';

const componentsModules = {
  UpdatePrintPreference,
  PrintPreference,
  PaidTimeOff,
  Sidebar,
  Emerg_Contacts,
  GWEmergContactsUpd,
  DashBoard,
  PasswordRecovery,
  EEpassword,
  EE_Language,
  Login,
  AppPage,
  AppHeader,
  PaidTimeOffDetails,
  Education,
  EducationAddEdit,
  EducationDetails,
  SalaryHistory,
  SalaryHistoryDetail,
  notificationElection,
  Dependents,
  GWDependents,
  GWDependentsAddDoc,
  TrainingClasses,
  TrainingEnrollment,
  Paystub,
  PaystubDetails,
  PayStubPrintPreview,
  BenefitsFTEMenu,
  BenefitsFTEPrsonalInfo,
  BenefitsFTEDependents,
  BenefitsFTEVerify,
  BenefitsFTEElectBenefits,
  BenefitsFTEReviewBenefits,
  BenefitsFTE,
  Email_Address,
  EMailAddrAddUpdate,
  PersonalData,
  PersonalDataEdit,
  VolSelfIdDis,
  VolSelfIdDisUpd,
  Footer,
  Employee_Direcotry,
  EEConsent1095C,
  EEConsentW2,
  EEW2ConsentFormUpdate,
  EEConsentFormUpdate,
  Employee_Files,
  JobReviews,
  JobReviewsDetail,
  EECertifications,
  CertificationsAddEdit,
  Address_Information,
  addInfoUpd,
  BenefitStatement,
  DirectDepositAccount,
  DirectDepositAccountListing,
  AddUpdateAccount,
  EESkills,
  EESkillsAddList,
  EESkillsAddSubmit,
  EESkillsUpdSubmit,
  PasswordExpiry,
  Total_Compensation_Stmt,
  W2history,
  FormC1095,
  AcceptPolicy,
  Benefit_Beneficiaries,
  Benefit_Beneficiaries_Detail,
  Beneficiaries_Detail_Upd,
  Rendered_Web_Page,
  BenefitsOPEMenu,
  BenefitsOPEPersonalInfo,
  BenefitsOPEDependents,
  BenefitsOPEVerify,
  BenefitsOPEElectBenefits,
  BenefitsOPEReviewBenefits,
  BenefitsOPE,
  PaycheckCalculator,
  PaycheckCalculatorResult,
  Retirement_Deduction,
  Retirement_Deduction_Add,
  W4_Forms,
  W4_Forms_date,
  W4_Forms_iframe,
  W4_Forms_fed,
  listingI9Listing,
  I9SummarylistContext,
  I9ListMenu,
  I9FirstReadInstruction,
  I9SecondPersonalInfo,
  I9ThirdCitizenship,
  I9FourthEligibility,
  I9EligibilityProceed,
  Mfa_header,
  Mfa_login,
  Onboarding,
  OnboardNavbar,
  W4,
  W4_date,
  BenefitsLifeEventsList,
  BenefitsLifeEventsMenu,
  BenefitsLifeEventsInfo,
  BenefitsLifeEventsDependent,
  BenefitsLifeEventsVerify,
  BenefitsLifeEventsElectBenefits,
  BenefitsLifeEventsReview,
  BenefitsLifeEvents,
  Login_Customer,

  /*mod Components*/
  ...modComponentsModules,
  Address_Information_W4,
};

export default componentsModules;
